import {AnyAction} from 'redux';
import {SET_CHAT_ROOM} from '../actionTypes';

export interface ChatRoomState {
  firstName: string;
  lastName: string;
  countryCode: string;
  mobilePhone: string;
}

const initialState: ChatRoomState = {
  firstName: '',
  lastName: '',
  countryCode: '',
  mobilePhone: '',
};

const chatRoom = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case SET_CHAT_ROOM:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return {...state};
  }
};

export default chatRoom;
